import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBlogs } from "../../../api/blogs";
import { resolveBlogImageSrc } from "../../../utils/blogImages";
import { isBlogPublished } from "../../../utils/blogStatus";
import BlogListLoader from "../../../components/Blog/BlogListLoader";
import "./Blog.css";

function stripHtml(value) {
    return String(value || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
}

export default function Blog () {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        const fetchBlogs = async () => {
            try {
                const data = await getBlogs();
                if (cancelled) return;
                const list = Array.isArray(data) ? data.filter(isBlogPublished) : [];
                setBlogs(list);
            } catch (err) {
                if (cancelled) return;
                const msg = err?.response?.data?.message || err?.message || "Failed to load blogs.";
                setError(msg);
            } finally {
                if (cancelled) return;
                setLoading(false);
            }
        };

        fetchBlogs();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <main className='main'>
            <div className="pbl-background">
                <div className="pbl-container">
                    <h2 className="pbl-title">
                        Our News & Blog
                    </h2>
                   {loading ? (
                        <BlogListLoader count={6} />
                    ) : error ? (
                        <div className="pbl-box">
                            <div className="pbl-state-card">{error}</div>
                        </div>
                    ) : blogs.length === 0 ? (
                        <div className="pbl-box">
                            <div className="pbl-state-card">No blogs published yet.</div>
                        </div>
                    ) : (
                        <div className="pbl-cards">
                            {blogs.map((blog) => {
                                const dateLabel = formatDate(blog?.createdAt);
                                const intro = blog?.intro || stripHtml(blog?.content || "");
                                const imageSrc = resolveBlogImageSrc(blog?.image) || blog?.image;
                                const blogSlug = blog?.slug || blog?._id;

                                return (
                                    <Link to={`/blogs/${blogSlug}`} className="pbl-item" key={blog?._id || blogSlug}>
                                        <div>
                                            <div className="pbl-image-wrap">
                                                {imageSrc ? <img src={imageSrc} alt={blog?.title || "Blog cover"} /> : null}
                                            </div>
                                            <h3 className="pbl-item-title">
                                                {blog?.title || "Untitled post"}
                                            </h3>
                                            <div className="pbl-item-desc-wrap">
                                                <p className="pbl-item-desc">
                                                    {intro ? `${intro.substring(0, 150)}${intro.length > 150 ? "..." : ""}` : "Read the full story."}
                                                </p>
                                            </div>
                                            <div className="pbl-meta-row">
                                                <div className="pbl-item-date">
                                                    {dateLabel}
                                                </div>
                                                <span className="pbl-read-more">
                                                    Read more
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
            {/* <Footer /> */}
        </main>
    )
}